<template>
  <div class="slidecontainer" :class="{ disabledField: isdisable }">
    <input
      type="range"
      :min="minvalue"
      :max="maxvalue"
      class="form-control-range"
      id="myRange"
      v-model="range"
      @change="sendResultValues"
      :disabled="isdisable"
    />
    <!-- <div
      class="progress-bar"
      v-bind:style="{
        position: 'absolute',
        width: `calc(${((range -
          minvalue) *
          100) /
          (maxvalue -
            minvalue) +
          '%'} - ${(24 /
          (maxvalue -
            minvalue)) *
          (range - minvalue)}px)`,
        height: '8px',
        borderRadius: '5px',
        top: '9px',
        transition: 'none !important',
      }"
    ></div> -->
  </div>
</template>

<script>
// import { vxm } from '@/store.vuex';
export default {
  data() {
    return {};
  },
  props: ['minvalue', 'maxvalue', 'range', 'isdisable'],
  // mounted() {
  //   this.range = this.appliedFilterRadius;
  // },
  watch: {
    range: function(val) {
      // console.log(vxm.jobs.FilterRadius, 'Range Value');
      this.sendResultValues();
    },
  },
  methods: {
    sendResultValues: function() {
      this.$emit('send-result-values', this.range);
    },
  },
};
</script>

<style scoped>
.slidecontainer {
  width: 100%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  cursor: pointer;
}
.disabledField {
  opacity: 0.5;
}
</style>
